var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-wrap f-row"},[_c('div',{staticClass:"con f-row"},[_vm._v(" 头部 ")])])
}]

export { render, staticRenderFns }